import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { COLLECTION_IDS } from "../../../shared/config/collections.js";
import { createAppApi } from "../../../shared/lib/store/createAppApi.js";
import { PerxisService } from "../../../shared/services/perxis/index.js";
import { dataFormatter } from "../../../shared/store/config/lib/dataFormatter.js";
import { getExtendedItems } from "../../../shared/store/reference/lib/getExtendedItems.js";
import { FormatterDataTypeEnum } from "../../../shared/types/formatter.js";
import { name } from "../config/name.js";
import { filterCitiesResponse } from "../lib/filterCitiesResponse.js";
import "@perxis-auto/shared";
import "react";
import "@perxis-auto/shared/lib";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "../../../shared/lib/logger/index.js";
import "react-router";
import "@perxis-auto/shared/lib/lib/is/isObject";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../model/selectors/selectCitiesParameters.js";
import "../model/selectors/selectCityParameters.js";
import "../model/selectors/selectDealershipParameters.js";
const api = createAppApi({
  reducerPath: name,
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    getDealership: builder.query({
      queryFn: async ({ referenceFields, ...parameters }, api2) => {
        const { itemsClient } = PerxisService.getInstance();
        const response = await itemsClient.getPublished({
          ...parameters,
          collectionId: COLLECTION_IDS.dealersDealership
        });
        const { item } = response;
        if (!item) {
          return {
            data: null
          };
        }
        const [extDealershipItem] = await getExtendedItems(api2, [item], {
          fields: referenceFields
        });
        const extendedDepartmentItems = await getExtendedItems(
          api2,
          extDealershipItem.data.departments.map((dep) => {
            return { data: dep };
          }),
          {
            fields: ["contacts", "schedules"]
          }
        );
        const resultantExtDealershipItem = {
          ...extDealershipItem,
          data: {
            ...extDealershipItem.data,
            departments: extendedDepartmentItems.map((dep) => dep.data)
          }
        };
        const formattedExtDealershipItem = dataFormatter(
          api2,
          FormatterDataTypeEnum.Dealership,
          resultantExtDealershipItem
        );
        return {
          data: formattedExtDealershipItem
        };
      }
    }),
    getCity: builder.query({
      queryFn: async ({ referenceFields, ...parameters }, api2) => {
        const { itemsClient } = PerxisService.getInstance();
        const response = await itemsClient.getPublished({
          ...parameters,
          collectionId: COLLECTION_IDS.dealersCities
        });
        const { item } = response;
        if (!item) {
          return {
            data: null
          };
        }
        const [extCityItem] = await getExtendedItems(api2, [item], {
          fields: referenceFields
        });
        const formattedExtCityItem = dataFormatter(api2, FormatterDataTypeEnum.City, extCityItem);
        return {
          data: formattedExtCityItem
        };
      }
    }),
    getCities: builder.query({
      queryFn: async (parameters, api2) => {
        const { itemsClient } = PerxisService.getInstance();
        const { result } = await itemsClient.aggregatePublished({
          ...parameters
        });
        const cityReferences = filterCitiesResponse(result == null ? void 0 : result.locations, COLLECTION_IDS.dealersCities);
        const referencesObjectToExtend = {
          data: {
            cities: cityReferences
          }
        };
        const [extendedRefencesObject] = await getExtendedItems(api2, [referencesObjectToExtend]);
        const cityItems = extendedRefencesObject.data.cities.map(
          (city) => ({
            id: city.id,
            envId: parameters.envId,
            spaceId: parameters.spaceId,
            collectionId: parameters.collectionId,
            data: city
          })
        );
        const extendedCityItems = await getExtendedItems(api2, cityItems, {
          fields: ["cluster"]
        });
        const formattedExtCityItems = dataFormatter(
          api2,
          FormatterDataTypeEnum.City,
          extendedCityItems
        );
        return {
          data: {
            items: formattedExtCityItems.map((extCity) => extCity.data)
          }
        };
      }
    })
  })
});
const {
  reducer,
  reducerPath,
  useGetCityQuery,
  useGetCitiesQuery,
  useGetDealershipQuery,
  useLazyGetCityQuery,
  useLazyGetDealershipQuery
} = api;
export {
  api,
  reducer,
  reducerPath,
  useGetCitiesQuery,
  useGetCityQuery,
  useGetDealershipQuery,
  useLazyGetCityQuery,
  useLazyGetDealershipQuery
};
